"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRBase = void 0;
const core_1 = require("../core");
const types_1 = require("./types");
const options_1 = require("./options");
const messages_1 = require("./messages");
const utils_1 = require("./utils");
class XHRBase extends core_1.CoreBasePluginModule {
    constructor(options) {
        super(options_1.xhrOptionsDefault, Object.assign({}, options));
        this.loaded = true;
    }
    pluginHandleRequest(data) {
        return this.executePluginMethod(types_1.XHRBasePluginMethods.HandleRequest, data);
    }
    pluginHandleResponse(data) {
        return this.executePluginMethod(types_1.XHRBasePluginMethods.HandleResponse, data);
    }
    sanitizeHeadersAndBody(headers, body) {
        if (!body) {
            return [Object.assign({}, headers), ''];
        }
        /**
         * NOTE: This was implemented adhoc for our Backoffice. We should consider a better approach
         * for this. Maybe a plugin?
         *
         * CONTEXT: When we send a FormData body the Content-Type header is set automatically by
         * the browser and it adds an automatic boundary id to the multipart/form-data.
         * PROBLEM: If the header is added manually without a boundary then the server
         * will not be able to parse the request because it expects a specific boundary id.
         * */
        if (body instanceof FormData) {
            const sanitizedHeaders = Object.assign({}, headers);
            delete sanitizedHeaders['content-type'];
            delete sanitizedHeaders['Content-type'];
            return [Object.assign({}, sanitizedHeaders), body];
        }
        if (body instanceof File || body instanceof Blob || body instanceof URLSearchParams) {
            return [Object.assign({}, headers), body];
        }
        return [Object.assign({}, headers), JSON.stringify(body)];
    }
    makeResponse(xhrResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = xhrResponse.getPluginResponseData();
            const xhrPluginResponse = yield this.pluginHandleResponse(data);
            const dataAfterPlugins = xhrPluginResponse.data;
            if (dataAfterPlugins.ok) {
                return dataAfterPlugins;
            }
            if (!dataAfterPlugins.message) {
                dataAfterPlugins.message = messages_1.XHRMessages.XHR_SERVICE_GENERIC_ERROR;
            }
            throw dataAfterPlugins;
        });
    }
    getResponseParams(xhrOptions) {
        this.validateLoaded();
        let options = xhrOptions;
        if (options) {
            options = (0, core_1.mergeDeep)(this.getOptions(), xhrOptions);
        }
        else {
            options = this.getOptions();
        }
        return { responseType: options.responseType };
    }
    getRequestParams(xhrOptions, url) {
        this.validateLoaded();
        if (xhrOptions) {
            xhrOptions.headers = xhrOptions.headers || {};
            xhrOptions.params = xhrOptions.params || {};
            xhrOptions = (0, core_1.mergeDeep)(this.getOptions(), xhrOptions);
        }
        else {
            xhrOptions = this.getOptions();
        }
        url = (0, utils_1.buildQueryString)(url, xhrOptions.params);
        const headers = (0, utils_1.buildHeaders)(xhrOptions.headers);
        return { url, headers };
    }
}
exports.XHRBase = XHRBase;
//# sourceMappingURL=XHRBase.js.map